import { useNavigate } from 'react-router'
import { COURSES } from '../data'
import { Button, WashiTape } from '../components/ui'
import { Podium } from './Podium'

const NAMES = ['Jan', 'Hans', 'Henk', 'Jeroen']

function generateLeaderboard() {
  const entries = []
  for (let i = 0; i < 50; i++) {
    const course = COURSES[Math.floor(Math.random() * COURSES.length)]
    const score = 45 + Math.floor(Math.random() * 30)
    const daysAgo = Math.floor(Math.random() * 30)
    const date = new Date()
    date.setDate(date.getDate() - daysAgo)
    entries.push({
      id: i.toString(),
      playerName: NAMES[Math.floor(Math.random() * NAMES.length)],
      score,
      course: course.name,
      courseId: course.id,
      date: date.toISOString().split('T')[0],
      timestamp: date.getTime(),
    })
  }
  return entries.sort((a, b) => a.score - b.score)
}

const leaderboard = generateLeaderboard()

export default function Leaderboard() {
  const navigate = useNavigate()
  const top10 = leaderboard.slice(0, 10)

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="text-center mb-4 relative">
        <WashiTape className="left-1/2 -translate-x-1/2 -top-3" rotation="-3deg" />
        <h1 className="text-3xl font-hand relative z-10">Klassement</h1>
      </div>

      <div className="flex-1 max-w-2xl w-full mx-auto space-y-4">
        <Podium
          topThree={top10.slice(0, 3).map((p) => ({ name: p.playerName, score: p.score, id: p.id }))}
        />

        <div className="space-y-2">
          {top10.map((entry, index) => (
            <div
              key={entry.id}
className={`flex items-center justify-between p-3 rounded-lg border ${
                  index < 3
                    ? 'bg-gradient-to-r from-yellow-50 to-transparent border-yellow-200 shadow-paper-sm'
                    : 'bg-muted border-border/40 shadow-paper-sm'
                }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${
                    index === 0
                      ? 'bg-yellow-500'
                      : index === 1
                      ? 'bg-gray-400'
                      : index === 2
                      ? 'bg-orange-700'
                      : 'bg-gray-300'
                  }`}
                >
                  {index + 1}
                </div>
                <div className="font-medium">{entry.playerName}</div>
              </div>
              <div className="text-right">
                <div className="text-xl font-bold">{entry.score}</div>
                <div className="text-xs text-muted-foreground">
                  {new Date(entry.date).toLocaleDateString()}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Button onClick={() => navigate('/')} variant="outline" className="w-full bg-card">
          Terug naar Baan Selectie
        </Button>
      </div>
    </div>
  )
}